import { useAppToast } from "@ui-seeker/app"
import { getSubmit } from "@ui-seeker/utils"

import { BACKEND_APIS } from "@constants"
import {
    isLoadingTable,
    tableData,
    totalCount
} from "../@signals"


export function fetchSkusByBrand(brandId, showToast) {
    if (!brandId) return

    isLoadingTable.value = true
    tableData.value = []

    getSubmit(`${BACKEND_APIS.SKU_MANAGEMENT}/list?id_brand=${brandId}`)
        .then(res => {
            if (res) {
                tableData.value = res.data || []
                totalCount.value = res.total || 0
            }
        })
        .catch(() => showToast?.error('Error loading SKUs'))
        .finally(() => {
            isLoadingTable.value = false
        })
}


export default function useSkuManagement() {
    const { showToast } = useAppToast()

    return {
        isLoading: isLoadingTable.value,
        data: tableData.value,
        total: totalCount.value,
        fetchSkus: (brandId) => fetchSkusByBrand(brandId, showToast)
    }
}
